<div>
  <smart-image #smartImage 
      (pointerEvent)="this.emitPointerEvent($event)" 
      (clickEvent)="this.emitClickEvent($event)"
      (click)="togglePointerEvent()"
      [showLineAt]="showLineAt" [overlayConfig]="selectedImage?.overlay ?? overlayConfig" 
      [showMetaData]="true" [src]="selectedImage?.src"
      [showZones]="showZones" [zones]="zones" >
  </smart-image>
  
  <!-- Video Generation Progress Modal -->
  <div *ngIf="isGeneratingVideo" class="video-generation-overlay">
    <div class="video-generation-modal">
      <h4>Generating Timelapse Video File</h4>
      <p>{{videoGenerationStatus}}</p>
      <div class="progress" style="height: 30px;">
        <div class="progress-bar progress-bar-striped progress-bar-animated" 
             role="progressbar" 
             [style.width.%]="videoGenerationProgress"
             [attr.aria-valuenow]="videoGenerationProgress" 
             aria-valuemin="0" 
             aria-valuemax="100">
          {{videoGenerationProgress}}%
        </div>
      </div>
      <div class="text-center mt-3">
        <button class="btn btn-danger" (click)="cancelVideoGeneration()">
          <i class="fa fa-times"></i> Cancel
        </button>
      </div>
    </div>
  </div>
  
  <div class="controls">
    <div class="controls-top">
      <div class="btn-group btn-group-sm">
        <button class="btn btn-sm btn-outline-secondary" [disabled]="!isLoaded" (click)="isPlay ? stop() : play()" title="Play/Stop">
          <i [ngClass]="{'fa-play': !isPlay, 'fa-stop':isPlay}" class="fa"></i>
        </button>
        <button class="btn btn-sm btn-outline-secondary" [disabled]="!isLoaded" (click)="prevImage()" title="Previous">
          <i class="fa fa-backward"></i>
        </button>
        <button class="btn btn-sm btn-outline-secondary" [disabled]="!isLoaded" (click)="nextImage()" title="Next">
          <i class="fa fa-forward"></i>
        </button>
        <button class="btn btn-sm btn-outline-secondary" [disabled]="!isLoaded" (click)="this.repeat = !this.repeat" [ngClass]="{'active':this.repeat}" title="Loop">
          <i class="fa fa-repeat"></i>
        </button>
        <button *ngIf="security.isAdmin()" title="Download Timelapse - Experimental" class="btn btn-sm btn-outline-secondary" [disabled]="!isLoaded || isGeneratingVideo" (click)="this.downloadVideo()">
          <i class="fa" [ngClass]="{'fa-spinner fa-spin': isGeneratingVideo, 'fa-download': !isGeneratingVideo}"></i>
        </button>
      </div>
      
      <div class="controls-slider">
        <input type="range" class="form-range" [attr.disabled]="isLoaded ? null : true" id="formControlRange" 
          min="0" [attr.max]="_images ? _images.length - 1 : 0" 
          [(ngModel)]="selectedImageIndex" (change)="changeImage()"/>
      </div>
      
      <div class="controls-info">
        <span class="frame-count">{{selectedImageIndex+1}}/{{_images?.length}}</span>
        <span class="timestamp" *ngIf="selectedImage">{{ selectedImage.timeStamp | date:'short' }}</span>
      </div>
    </div>
  </div>
</div>